export const validationMessages = {
  required: (fieldName: string) =>
    `${
      fieldName?.charAt(0).toUpperCase() + fieldName?.slice(1).toLowerCase()
    } is required.`,
  format: (fieldName: any) => ` ${fieldName} should be in correct format.`,
  atLeastOneSelected: (fieldName: any) =>
    `At least one ${fieldName} must be selected.`,
  passwordLength: (fieldName: any, minLength: any) =>
    `${fieldName} should be at least ${minLength} characters.`,
  contactLength: (fieldName: string, minLength: any) =>
    `${
      fieldName.charAt(0).toUpperCase() + fieldName.slice(1).toLowerCase()
    } should be ${minLength} digit.`,
  passwordComplexity: (fieldName: any) =>
    `${fieldName} should be an uppercase lowercase number and special characters.`,
  passwordsMatch: (fieldName: any, confirmFieldName: any) =>
    `${
      fieldName.charAt(0).toUpperCase() + fieldName.slice(1).toLowerCase()
    } and ${confirmFieldName.toLowerCase()} should be same.`,
  phoneNumber: (fieldName: string) =>
    `Invalid ${fieldName.toLowerCase()} format.`,
  notSameAsField: (fieldName: any, comparedField: any) =>
    `${fieldName} should be different from ${comparedField}.`,
  maxChar: (fieldName: any, maxLength: any) =>
    `${
      fieldName.charAt(0).toUpperCase() + fieldName.slice(1).toLowerCase()
    } should be ${maxLength} Characters.`,
  maxLength: (fieldName: any, maxLength: any) =>
    `${
      fieldName.charAt(0).toUpperCase() + fieldName.slice(1).toLowerCase()
    } should be maximum ${maxLength} digits.`,
  minLength: (fieldName: any, minLength: any) =>
    `${
      fieldName.charAt(0).toUpperCase() + fieldName.slice(1).toLowerCase()
    } should be minimum ${minLength} digits.`,
  positiveNumber: (fieldName: any) =>
    `${
      fieldName.charAt(0).toUpperCase() + fieldName.slice(1).toLowerCase()
    } should be positive`,
  url: (field: any) => `${field} should be a valid URL`,
  greaterThan: (fieldName: any, comparedField: any) =>
    `${comparedField} should be greater than or equal to ${fieldName}.`,
  greaterTime: (fieldName: any, comparedField: any) =>
    `${comparedField} should be greater than ${fieldName}.`,
  lessThan: (fieldName: any, comparedField: any) =>
    `${comparedField} should be less than or equal to ${fieldName.toLowerCase()}.`,
  otpFormat: (fieldName: any) => `${fieldName} should be in number digit.`,
};

export const fileLimitErrorMessage =
  "File Size is too Large! (more than 1 MB).";
export const fileTypePDFErrorMessage = "Only PDF is allowed.";
export const fileTypePDFJPGPNGErrorMessage = "Only PDF, JPEG and PNG are allowed.";

export const InputPlaceHolder = (fieldName: string) => {
  return `Enter ${fieldName?.toLowerCase()}`;
};

export const SelectPlaceHolder = (fieldName: string) => {
  return `Select ${fieldName?.toLowerCase()}`;
};

export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/;
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,3}(?![^.\s])/;
export const numberRegex = /^\d{10}$/;
export const digitRegex = /^\d*$/;
export const aadharRegex = /^\d{12}$/;
export const zipcodeRegex = /^\d{6}$/;
export const GSTINRegex =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;
export const bankNumberRegex = /^\{8,17}$/;
export const ifscRegex = /^.{11}$/;
export const positiveNumberRegex =
  /^[+]?([1-9][0-9]*(?:[\.][0-9]*)?|0*\.0*[1-9][0-9]*)(?:[eE][+-][0-9]+)?$/;
export const panRegex = /^.{10}$/;
export const otpRegex = /^\d{6}$/;
export const otpTypeRegex = /^\d{0,6}$/;
export const negDigitRegex = /^-?\d*$/;
